import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { router } from '@/router';
import PageService from '@/core/page.service';
import ProductRegistrationService from '@/services/product-registration.service';
import RegisteredProductActions from './RegisteredProductActions.vue';
import ProductRegistrationActionService from './product-registration-action.service';
import SelfServiceModal from '@/ui/shared/modals/SelfServiceModal.vue';
import RegisteredProductViewObject = Vertica.LouisPoulsen.Application.ProductRegistration.Responses.RegisteredProductViewObject;
import RegisteredProductStatus = Vertica.LouisPoulsen.Application.ProductRegistration.Enums.RegisteredProductStatus;
import SmallCheck from './SmallCheck.vue';
import PdfUpload from '@/ui/shared/imageupload/PdfUpload.vue';
import ImageUploadService from '@/ui/shared/imageupload/image-upload.service';
import { store } from '@/store';
import { useRegisteredProductActions } from './registered-product-actions.composable';
import AutoOptimizedImageWithZoom from '@/ui/shared/image/auto-optimized-image-with-zoom/AutoOptimizedImageWithZoom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisteredProductPage',
  props: {
    marketingUrl: null,
    dashboardUrl: null,
    editProductPageUrl: null
  },
  setup(__props: any) {

const props = __props as {
    marketingUrl: string,
    dashboardUrl: string,
    editProductPageUrl: string
}



const status = ref<RegisteredProductStatus>();
const product = ref<RegisteredProductViewObject>();
const receipt = ref<CarouselImageWithExtension>();
const images = ref<CarouselImageWithExtension[]>([]);
const productId = ref<string>(null);

const showActionModal = ref<boolean>(false);

const receiptZoomEnabled = ref<boolean>(false);
const imageZoomEnabled = ref<boolean>(false);

onMounted(() => {
    checkIfRedirectedByAction();
    const id = router.currentRoute.query.id as string;
    productId.value = id;
    ProductRegistrationService.getProduct(productId.value).then((data) => {
        status.value = data.status;
        product.value = data.registeredProduct;
        images.value = data.images.map(ImageUploadService.mapUploadedImageForView);
        receipt.value = data.receipt ? ImageUploadService.mapUploadedImageForView(data.receipt) : null;

        setCustomBreadcrumbStyling(product.value.image ? null : 'sub-lg:u-pt-5');
    });
});

onBeforeUnmount(() => { setCustomBreadcrumbStyling(null); });

function checkIfRedirectedByAction() {
    const context = ProductRegistrationActionService.GetActionContext();
    if (context) {
        showActionModal.value = true;
        actionProductName.value = context.name;
        actionType.value = context.action;
        ProductRegistrationActionService.DeleteActionContext();
    }
}

const isPdf = ImageUploadService.isPdf;

function hideActionModal() {
    showActionModal.value = false;
}

function renderPropertyValue(value: string) {
    return !value || value === 'null' ? ' -' : value;
}

function returnToDashboardPage() {
    PageService.softRedirect(props.dashboardUrl);
}

function redirectToSelectedLink() {
    PageService.softRedirect(props.marketingUrl);
}

function setCustomBreadcrumbStyling(styling) {
    store.dispatch('app/setCustomBreadcrumbStyling', styling);
}

const { actionType, actionProductName, actionTitle, actionText } = useRegisteredProductActions();

return { __sfc: true,props, status, product, receipt, images, productId, showActionModal, receiptZoomEnabled, imageZoomEnabled, checkIfRedirectedByAction, isPdf, hideActionModal, renderPropertyValue, returnToDashboardPage, redirectToSelectedLink, setCustomBreadcrumbStyling, actionType, actionProductName, actionTitle, actionText, RegisteredProductActions, SelfServiceModal, SmallCheck, PdfUpload, AutoOptimizedImageWithZoom }
}

})